import useCodeBooks from '@aytm/app/stats/page/comments/comments/hooks/useCodeBooks'
import useTags from '@aytm/app/stats/page/comments/comments/hooks/useTags'

const useEventBus = ({ mode = 'comments', survey, tagsData, request, onFetch, onTagsFetch }) => {
  const [_onTagsUpdateSchema, _onTagsFetch] = useTags({
    survey,
    tagsData,
    request,
    onFetch,
    onTagsFetch
  })

  const [_onCodeBooksFetch] = useCodeBooks({
    survey,
    tagsData,
    request,
    onFetch,
    onTagsFetch
  })

  return ['comments', 'video-responses'].includes(mode)
    ? {
        _onTagsFetch: (data, updated) => {
          dispatchEvent(new CustomEvent('tagsFetch', { detail: { data, updated } }))
        },
        _onCodeBooksFetch: (data, updated) => {
          dispatchEvent(new CustomEvent('codeBooksFetch', { detail: { data, updated } }))
        }
      }
    : { _onTagsFetch, _onCodeBooksFetch }
}

export default useEventBus
